var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHexagonLogo = function SvgHexagonLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33 0H11L0 19l11 19h22l11-19zm-2.95 26.546v-10.68l-6.502 10.68-.007-.004-.002.004h-3.05V15.81l-5.243 8.614a421 421 0 0 0-1.268 2.12h-3.08v-15.09h3.08l-.029 9.358.018.584 6.052-9.943.005.004v-.004h3.486s.024 8.322.03 9.98l6.074-9.98.005.004v-.004h3.482v15.092z"
  })));
};
export default SvgHexagonLogo;